import excelIcon from '@/assets/images/download-format/excel.png'

export default [
  { 
    label: 'ACCURATE', 
    type: 'excel', 
    icon: excelIcon, 
    code: 'ACCURATE', 
    endpoint: '/transaction/export/accurate/other-payment' 
  },
]